"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
function useAggregatedError(error) {
    const [aggregatedError, setAggregatedError] = React.useState({
        environment: navigator.userAgent,
        error: new Error(),
        errorStackWithoutHeader: "No stack available",
        message: error.message ? error.message : "No message provided",
        timestamp: new Date().toISOString(),
        url: window.location.href,
    });
    React.useEffect(() => {
        // We don't want it to crash the error handler when someone forgot to pass an error
        if (!(error instanceof Error)) {
            const placeholderError = new TypeError("No error given to debug component");
            // tslint:disable-next-line
            console.error(placeholderError);
            setAggregatedError({ ...aggregatedError, error: placeholderError });
        }
        // Populate extra debug information
        let errorStackWithoutHeader;
        if (!error.stack) {
            errorStackWithoutHeader = "No stack available";
        }
        else {
            errorStackWithoutHeader = error.stack.split("\n").slice(1).join("\n");
        }
        setAggregatedError({
            ...aggregatedError,
            environment: navigator.userAgent,
            errorStackWithoutHeader,
            message: error.message ? error.message : "No message provided",
            timestamp: new Date().toISOString(),
            url: window.location.href,
        });
    }, [error]);
    return aggregatedError;
}
exports.default = useAggregatedError;
